// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-suggestions {
    color: #999;
    padding: 0.5rem;
}
  
.suggestions {
    border: 1px solid #999;
    border-top-width: 0;
    list-style: none;
    margin-top: 0;
    max-height: 143px;
    overflow-y: auto;
    padding-left: 0;
    width: 100%;
}
  
.suggestions li {
    padding: 0.5rem;
}
  
.suggestion-active,
.suggestions li:hover {
    background-color: #008f68;
    color: #fae042;
    cursor: pointer;
    font-weight: 700;
}
  
.suggestions li:not(:last-of-type) {
    border-bottom: 1px solid #999;
}

.appointment-form .appointment-field ul.suggestions li{
    border-bottom: 0;
    padding-left: 15px;
 
}
.appointment-form .appointment-field ul.suggestions li.suggestion-active{
    background-color: unset;
    font-weight: unset;
    color: #212529;
}
.appointment-form .appointment-field ul.suggestions li:hover{
    background-color: unset;
    font-weight: unset;
    color: #212529;
    border-bottom: 1px solid #067e06;
}
.appointment-form .appointment-field ul.suggestions{
    width: 92%;
    overflow: auto;
    position: absolute;
    z-index: 1;
    background-color: white;
    height: auto;
    max-width: 624px;
}`, "",{"version":3,"sources":["webpack://./src/components/appointmentScheduler/addressSuggestion.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".no-suggestions {\n    color: #999;\n    padding: 0.5rem;\n}\n  \n.suggestions {\n    border: 1px solid #999;\n    border-top-width: 0;\n    list-style: none;\n    margin-top: 0;\n    max-height: 143px;\n    overflow-y: auto;\n    padding-left: 0;\n    width: 100%;\n}\n  \n.suggestions li {\n    padding: 0.5rem;\n}\n  \n.suggestion-active,\n.suggestions li:hover {\n    background-color: #008f68;\n    color: #fae042;\n    cursor: pointer;\n    font-weight: 700;\n}\n  \n.suggestions li:not(:last-of-type) {\n    border-bottom: 1px solid #999;\n}\n\n.appointment-form .appointment-field ul.suggestions li{\n    border-bottom: 0;\n    padding-left: 15px;\n \n}\n.appointment-form .appointment-field ul.suggestions li.suggestion-active{\n    background-color: unset;\n    font-weight: unset;\n    color: #212529;\n}\n.appointment-form .appointment-field ul.suggestions li:hover{\n    background-color: unset;\n    font-weight: unset;\n    color: #212529;\n    border-bottom: 1px solid #067e06;\n}\n.appointment-form .appointment-field ul.suggestions{\n    width: 92%;\n    overflow: auto;\n    position: absolute;\n    z-index: 1;\n    background-color: white;\n    height: auto;\n    max-width: 624px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
